module Meevo.Components.Common {

    export type Listener = (...args: any[]) => any;

    interface IEvents {
        [key: string]: Listener[];
    }

    export class MeevoEventEmitter {

        private readonly events: IEvents;

        constructor() {
            this.events = {};
        }

        public once(eventName: string, listener: Listener) {
            const fn = (...args: any[]) => {
                listener(...args);

                this.removeListener(eventName, listener);
            };

            this.on(eventName, fn);
        }

        public on(eventName: string, listener: Listener) {
            if (typeof this.events[eventName] !== 'object') {
                this.events[eventName] = [];
            }

            this.events[eventName].push(listener);
        }

        public removeListener(eventName: string, listener: Listener) {
            if (typeof this.events[eventName] !== 'object') {
                return;
            }
            let idx = this.events[eventName].indexOf(listener);

            if (idx > -1) {
                this.events[eventName].splice(idx, 1);
            }
        };

        public emit(eventName: string, ...args: any[]) {

            if (typeof this.events[eventName] !== 'object') {
                return;
            }

            this.events[eventName].forEach(ev => ev(...args));
        }
    }
}
